import { findParentNodeClosestToPos } from "@tiptap/core";
import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from "./../ricos-content";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3";
import { COLLAPSIBLE_LIST_SETTINGS_MODAL_ID } from "./consts";
import { CollapsibleListSettingsModal } from "./modals/SettingsModals";
const getToolbarButtons = (config, { modals }) => {
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        modals.togglePluginPanel({
          id: COLLAPSIBLE_LIST_SETTINGS_MODAL_ID,
          Component: CollapsibleListSettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            isQapageDataEnabled: !!config?.isQapageData
          },
          isMobile,
          positioning: {
            referenceElement: referenceElement.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          focusReturnElement: referenceElement
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver,
        active: {
          id: "IS_COLLAPSIBLE_LIST_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }, __) => Boolean(modals2.getModal(COLLAPSIBLE_LIST_SETTINGS_MODAL_ID))
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      attributes: {
        selectedNode: selectedNodeResolver
      }
    }
  ];
};
const selectedNodeResolver = {
  id: "selectedNode",
  resolve: (_, __, editor) => {
    const { selection } = editor?.state || {};
    return findParentNodeClosestToPos(
      selection.$to,
      (node) => node?.type?.name === TIPTAP_COLLAPSIBLE_LIST_TYPE
    )?.node;
  }
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
